import { getENVPath } from 'helper';
import ApiClientManager from './ApiClientManager';

const apiClientManager = ApiClientManager.getInstance();

const ApiStore = () => {
  return {
    FJ: apiClientManager.createClient(getENVPath().NEXT_PUBLIC_FJ_URL),
    JOBS: apiClientManager.createClient(getENVPath().NEXT_PUBLIC_JOBS_URL_RJ),
    EB: apiClientManager.createClient(getENVPath().NEXT_PUBLIC_EB_URL),
  };
};

export default ApiStore;
